<template>
  <div class="message-analysis">
    <div class="img-container relative">
      <img :src="item.image" :alt="item.text" class="w-full absolute" />
      <button class="button absolute py-1 px-3" @click="$emit('learn-more', item.text)">
        {{ $t('chat.learn_more') }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  computed: {
    item() {
      return this.message.content[0];
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.message-analysis {
  padding: 16px;
  color: #fff;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;

  .img-container {
    padding-top: 87.7%;
    border-radius: 8px;

    img {
      top: 0;
      left: 0;
      max-width: 100%;
    }

    .button {
      font-size: 12px;
      line-height: 1.5;
      border-radius: 38px;
      border: 1px solid var(--primary-text);
      right: 12px;
      bottom: 12px;
      background-color: rgba(0, 0, 0, 0.6);
      outline: none;

      &:active {
        background-color: var(--primary-text);
        color: var(--primary-button-text);
      }
    }
  }
}
</style>
